// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderCartButton_wrapper__CT8i1","textDiv":"HeaderCartButton_textDiv__w-UhM","floatingContentWrapper":"HeaderCartButton_floatingContentWrapper__-3rnH"};